import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, PRIMARY_OUTLET, Router, RouterStateSnapshot, UrlSegment, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {RouteParameter} from "@biletix/core/common/constants/route-parameter.const";
import {I18nService} from "@biletix/core/services/i18n.service";
import {LocalStorageService} from "@biletix/core/services/local-storage.service";
import {Location} from "@angular/common"; 

/**
 * Url üzerinden dil seçeneği değiştirildiğinde veya url refresh olduğunda kontrol edilir.
 */
@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate {

  constructor(private i18n: I18nService,
              private localStorage: LocalStorageService,
              private location:Location,
              private router: Router) {
  }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    //console.log("Language guard started");
    const lang = route.params[RouteParameter.PARAMS.LANGUAGE];
    if (lang){
      let isAvailableLanguage=this.i18n.isAvailableLanguage(lang);

      //console.log(lang+ "language is available : "+isAvailableLanguage);
      if(!isAvailableLanguage){
        return this.replaceLanguage(state.url, lang);
      }
    } else {
      const ticketLinkWithLanguage = this.appendDefaultLanguageToTicketLink(state.url);
      if (ticketLinkWithLanguage) {
        return ticketLinkWithLanguage;
      }
    }

    // if (locale) {
    //   if (this.i18n.currentLang != locale.lang) {
    //     this.i18n.useLanguage(locale);
    //   }
    // } else {
    //   //TODO: Geçersiz bir dil seçeneği ise eski dil seçeneğine dön, veya direk Anasayfaya dön
    //   this.location.back();
    // }
   // console.log("Language guard ended");
    return true;
  }

  /**
   * Dilsiz bilet linkini (`/t/:scode/:refcode`) `/t/:scode/:refcode/tr` adresine yönlendirir.
   *
   * Eskiden `state.url + '/tr'` + `navigateByUrl` vardı. Query string ya da fragment varsa `/tr`
   * onların sonuna ekleniyordu (`/t/A/B?x=1` → `/t/A/B?x=1/tr`), path değişmediği için guard yine
   * dilsiz route'ta çalışıyor ve tarayıcı sonsuz navigasyona giriyordu. Segment path'e eklenir,
   * query ve fragment korunur; yeni adres dilli route'a düştüğü için döngü oluşmaz.
   */
  private appendDefaultLanguageToTicketLink(url: string): UrlTree | null {
    const tree = this.router.parseUrl(url);
    const segments = tree.root.children[PRIMARY_OUTLET]?.segments ?? [];
    if (segments.length !== 3 || segments[0].path !== 't') {
      return null;
    }
    segments.push(new UrlSegment('tr', {}));
    return tree;
  }

  /**
   * Geçersiz dil segmentini `tr` yapan adrese yönlendirir (SSR'da 302).
   *
   * Eskiden `state.url.replace('/' + lang, '/tr')` + `navigateByUrl` vardı. `state.url` kodlanmış
   * olduğundan `[` gibi karakterler (`%5B`) hiç eşleşmiyor, aynı URL'e tekrar gidiliyor ve guard
   * kendini sonsuza dek çağırıyordu: `/anasayfa/TURKIYE/[` isteği worker'ı %100 CPU'da kilitliyordu.
   * Segmentler çözülmüş halde karşılaştırılır; bulunamazsa anasayfaya gidilir, döngü oluşmaz.
   */
  private replaceLanguage(url: string, lang: string): UrlTree {
    const tree = this.router.parseUrl(url);
    const segments = tree.root.children[PRIMARY_OUTLET]?.segments ?? [];
    const index = segments.map(segment => segment.path).lastIndexOf(lang);
    if (index < 0) {
      return this.router.parseUrl('/');
    }
    segments[index] = new UrlSegment('tr', {});
    return tree;
  }

}
